import { getDocument } from "@thelabnyc/thelabui/src/utils/dom";

import { focusElement } from "../../utils/keyboardFocus";

// Radix restores focus via onCloseAutoFocus only when the opening trigger is still
// mounted at close time. Financing opens through Redux (no Dialog.Trigger), and
// minicart entry points can unmount before close — capture the opener on click instead.
// Only one financing modal instance is expected to be open at a time.
let financingModalTriggerElement: HTMLElement | null = null;

export const captureFinancingModalTrigger = (element: HTMLElement): void => {
    financingModalTriggerElement = element;
};

export const returnFocusToFinancingModalTrigger = (): void => {
    const document = getDocument();
    if (!document) {
        financingModalTriggerElement = null;
        return;
    }

    const trigger = financingModalTriggerElement;
    financingModalTriggerElement = null;

    if (trigger && document.contains(trigger)) {
        focusElement(trigger);
        return;
    }

    document.body.setAttribute("tabindex", "-1");
    focusElement(document.body);
    document.body.removeAttribute("tabindex");
};
